import warningGeneral from "../../assets/warningGeneral.png";
import { useNavigate } from "react-router-dom";
import Button from "../../Components/Button";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

function KycModal({ open, onClose }) {
  const navigate = useNavigate();

  const handleProceed = () => {
    navigate("/verification");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex justify-center mb-3">
          <img src={warningGeneral} alt="error icon" width="60px" />
        </div>
        <p className="text-center text-xl font-semibold mb-4">
          Not KYC Verified
        </p>
        <p className="text-[#60656D] text-center mb-4">
          Please verify your KYC information to proceed with the transaction.
        </p>
        <Button className="w-full text-white" onClick={handleProceed}>
          Get Started
        </Button>
      </div>
    </Modal>
  );
}

KycModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default KycModal;
